import React from 'react'

function ChevronRightIcon() {
  return (
    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.53634 5.44743C6.88177 5.73529 6.88177 6.26582 6.53634 6.55367L1.18102 11.0164C0.712062 11.4072 8.53539e-05 11.0738 8.53539e-05 10.4633L8.53539e-05 1.53778C8.53539e-05 0.927339 0.712063 0.593867 1.18102 0.984663L6.53634 5.44743Z" fill="#6D6F81" />
    </svg>

  )
}

export default ChevronRightIcon